/**
 * Mapping from GTFS numeric route types to human-readable string values
 */
const routeTypes = {
  // Core types - from: https://developers.google.com/transit/gtfs/reference/#routestxt
  '0': 'light rail',
  '1': 'subway',
  '3': 'bus',
  '4': 'ferry',
  '5': 'cable tram',
  '6': 'aerial lift',
  '7': 'funicular',

  // Extended types - from: https://developers.google.com/transit/gtfs/reference/extended-route-types
  '100': 'railway',
  '101': 'high speed rail',
  '102': 'long distance trains',
  '103': 'inter regional rail',
  '104': 'car transport rail',
  '105': 'sleeper rail',
  '106': 'regional rail',
  '107': 'tourist railway',
  '108': 'rail shuttle (within complex)',
  '109': 'suburban railway',
  '110': 'replacement rail',
  '111': 'special rail',
  '112': 'lorry transport rail',
  '113': 'all rails',
  '114': 'cross-country rail',
  '115': 'vehicle transport rail',
  '116': 'rack and pinion railway',
  '117': 'additional rail',
  '200': 'coach',
  '201': 'international coach',
  '202': 'national coach',
  '203': 'shuttle coach',
  '204': 'regional coach',
  '205': 'special coach',
  '206': 'sightseeing coach',
  '207': 'tourist coach',
  '208': 'commuter coach',
  '209': 'all coachs',
  '300': 'suburban railway',
  '400': 'urban railway',
  '401': 'metro',
  '402': 'underground',
  '403': 'urban railway',
  '404': 'all urban railways',
  '405': 'monorail',
  '500': 'metro',
  '600': 'underground',
  '700': 'bus',
  '701': 'regional bus',
  '702': 'express bus',
  '703': 'stopping bus',
  '704': 'local bus',
  '705': 'night bus',
  '706': 'post bus',
  '707': 'special needs bus',
  '708': 'mobility bus',
  '709': 'mobility bus for registered disabled',
  '710': 'sightseeing bus',
  '711': 'shuttle bus',
  '712': 'school bus',
  '713': 'school and public bus',
  '714': 'rail replacement bus',
  '715': 'demand and response bus',
  '716': 'all buss',
  '717': 'share taxi',
  '800': 'trolleybus',
  '900': 'tram',
  '901': 'city tram',
  '902': 'local tram',
  '903': 'regional tram',
  '904': 'sightseeing tram',
  '905': 'shuttle tram',
  '906': 'all trams',
  '907': 'cable tram',
  '1000': 'water transport',
  '1001': 'international car ferry',
  '1002': 'national car ferry',
  '1003': 'regional car ferry',
  '1004': 'local car ferry',
  '1005': 'international passenger ferry',
  '1006': 'national passenger ferry',
  '1007': 'regional passenger ferry',
  '1008': 'local passenger ferry',
  '1009': 'post boat',
  '1010': 'train ferry',
  '1011': 'road-link ferry',
  '1012': 'airport-link ferry',
  '1013': 'car high-speed ferry',
  '1014': 'passenger high-speed ferry',
  '1015': 'sightseeing boat',
  '1016': 'school boat',
  '1017': 'cable-drawn boat',
  '1018': 'river bus',
  '1019': 'scheduled ferry',
  '1020': 'shuttle ferry',
  '1021': 'all water transports',
  '1100': 'air',
  '1101': 'international air',
  '1102': 'domestic air',
  '1103': 'intercontinental air',
  '1104': 'domestic scheduled air',
  '1105': 'shuttle air',
  '1106': 'intercontinental charter air',
  '1107': 'international charter air',
  '1108': 'round-trip charter air',
  '1109': 'sightseeing air',
  '1110': 'helicopter air',
  '1111': 'domestic charter air',
  '1112': 'schengen-area air',
  '1113': 'airship',
  '1114': 'air',
  '1200': 'ferry',
  '1300': 'aerial lift',
  '1301': 'telecabin',
  '1302': 'aerial tramway',
  '1303': 'elevator',
  '1304': 'chair lift',
  '1305': 'drag lift',
  '1306': 'small telecabin',
  '1307': 'all telecabins',
  '1400': 'funicular',
  '1401': 'funicular',
  '1402': 'all funicular',
  '1500': 'taxi',
  '1501': 'communal taxi',
  '1502': 'water taxi',
  '1503': 'rail taxi',
  '1504': 'bike taxi',
  '1505': 'licensed taxi',
  '1506': 'private hire vehicle',
  '1507': 'taxi',
  '1600': 'self drive',
  '1601': 'hire car',
  '1602': 'hire van',
  '1603': 'hire motorbike',
  '1604': 'hire cycle',
  '1700': 'miscellaneous'
}

/**
 * Define the type for the human-readable route types
 * This creates a union type of all the string values in the routeTypes object
 */
export type EnhancedRouteType = (typeof routeTypes)[keyof typeof routeTypes]

export default routeTypes
